import { ChangeDetectionStrategy, Component, Optional } from '@angular/core';
import { Catalog } from '@df/catalog/catalog.interfaces';
import { DfCmsModal } from '@df/ui/modal/df-cms-modal.decorator';
import { NDfModal } from '@df/ui/modal/df-modal.interface';
import { ModalRef } from '@df/ui/modal/modal-ref';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsComponent, ICmsContent, NICmsContentComponent, NICmsContentField } from '@icms/core/content';
import { NModalLayoutLeft } from '../../ui/modal/modal-layout-left.component';
import { OffCanvasSearchTrayComponent } from './off-canvas-search-tray.component';
export interface IOffCanvasSearchTrayModalBlockData extends Catalog.IBlockData<IOffCanvasSearchTrayModalBlockDataContent> {
}
export interface IOffCanvasSearchTrayModalBlockDataContent {
    title: string;
    featuredItems: IOffCanvasSearchTrayModalFeaturedData[];
}
export interface IOffCanvasSearchTrayModalFeaturedData {
    image: string;
    copy: string;
    link: string;
}

export const offCanvasFields =  [
    <NICmsContentField.IField>{
        key: 'title',
        type: NICmsContentField.EFieldType.text,
        title: 'Title',
        required: true
    },
    <NICmsContentField.IRepeaterField>{
        type: NICmsContentField.EFieldType.repeater,
        key: 'featuredItems',
        title: 'Featured Items',
        itemName: 'item',
        itemNameField: 'item',
        defaultSize: 1,
        fields: [
            <NICmsContentField.IField>{
                key: 'image',
                type: NICmsContentField.EFieldType.image,
                title: 'Choose image',
                required: true
            },
            <NICmsContentField.IField>{
                key: 'copy',
                type: NICmsContentField.EFieldType.text,
                title: 'Copy',
                required: false
            },
            <NICmsContentField.IField>{
                key: 'link',
                type: NICmsContentField.EFieldType.text,
                title: 'Link',
                required: false
            }
        ]
    }
]
@DfCmsModal({
    id: 'offCanvas_search_tray',
    name: 'Offcanvas Search Tray',
    position: 'custom',
    config: sizeName => ({
        ...NModalLayoutLeft.ModalConfig,
        width: NModalLayoutLeft.getWidth(sizeName)
    }),
    reopenPolicy: NDfModal.ReopenPolicy.first,
    sizeRestriction: ['S', 'M']
})
@ICmsComponent<OffCanvasSearchTrayModalComponent>({
    id: 'offCanvas_search_tray',
    block: {
        url: 'offCanvas_search_tray',
    },
    onDemandOnly: true,
    name: 'Search Tray',
    description: 'Search Tray',
    fields: offCanvasFields
})
@Component({
    selector: 'off-canvas-search-tray-modal',
    templateUrl: 'off-canvas-search-tray-modal.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [OffCanvasSearchTrayComponent]
})
export class OffCanvasSearchTrayModalComponent extends UiComponent implements NICmsContentComponent.IComponent {
    @ICmsContent({
        type: 'blockContent'
    })
    content?: IOffCanvasSearchTrayModalBlockDataContent;

    constructor(
        @Optional()
        private modalRef: ModalRef<OffCanvasSearchTrayModalComponent>
    ) {
        super();
    }
    close() {
        this.modalRef?.close();
    }
}
